export interface LabelNameMap {
   key: string;
   title: string;
   description?: string;
}
export const firstStepLabelMap: Record<string, LabelNameMap> = {
   legalRegulationsKnowledge: {
      key: 'legalRegulationsKnowledge',
      title: 'LEGAL_REGULATIONS_KNOWLEDGE_TITLE',
      description: 'LEGAL_REGULATIONS_KNOWLEDGE_DESCRIPTION',
   },
   targetGroupKnowledge: {
      key: 'targetGroupKnowledge',
      title: 'TARGET_GROUP_KNOWLEDGE_TITLE',
   },
   professionalKnowledgeApplication: {
      key: 'professionalKnowledgeApplication',
      title: 'PROFESSIONAL_KNOWLEDGE_APPLICATION_TITLE',
   },
   caseManagementProcessKnowledge: {
      key: 'caseManagementProcessKnowledge',
      title: 'CASE_MANAGEMENT_PROCESS_KNOWLEDGE_TITLE',
   },
   professionalProceduresKnowledge: {
      key: 'professionalProceduresKnowledge',
      title: 'PROFESSIONAL_PROCEDURES_KNOWLEDGE_TITLE',
   },
   caseDocumentation: {
      key: 'caseDocumentation',
      title: 'CASE_DOCUMENTATION_TITLE',
      description: 'CASE_DOCUMENTATION_DESCRIPTION',
   },
   independentCaseHandling: {
      key: 'independentCaseHandling',
      title: 'INDEPENDENT_CASE_HANDLING_TITLE',
   },
   teamFormationAssessment: {
      key: 'teamFormationAssessment',
      title: 'TEAM_FORMATION_ASSESSMENT_TITLE',
   },
};

export const secondStepLabelMap: Record<string, LabelNameMap> = {
   activeListening: {
      key: 'activeListening',
      title: 'ACTIVE_LISTENING_TITLE',
      description: 'ACTIVE_LISTENING_DESCRIPTION',
   },
   counselingAndSupportSkills: {
      key: 'counselingAndSupportSkills',
      title: 'COUNSELING_AND_SUPPORT_SKILLS_TITLE',
      description: 'COUNSELING_AND_SUPPORT_SKILLS_DESCRIPTION',
   },
   interviewingSkills: {
      key: 'interviewingSkills',
      title: 'INTERVIEWING_SKILLS_TITLE',
      description: 'INTERVIEWING_SKILLS_DESCRIPTION',
   },
   assertivenessAndBoundarySettingSkills: {
      key: 'assertivenessAndBoundarySettingSkills',
      title: 'ASSERTIVENESS_AND_BOUNDARY_SETTING_SKILLS_TITLE',
   },
   writtenCorrespondenceSkills: {
      key: 'writtenCorrespondenceSkills',
      title: 'WRITTEN_CORRESPONDENCE_SKILLS_TITLE',
   },
   negotiationSkills: {
      key: 'negotiationSkills',
      title: 'NEGOTIATION_SKILLS_TITLE',
   },
   teamwork: {
      key: 'teamwork',
      title: 'TEAMWORK_TITLE',
      description: 'TEAMWORK_DESCRIPTION',
   },
   expressionCulture: {
      key: 'expressionCulture',
      title: 'EXPRESSION_CULTURE_TITLE',
      description: 'EXPRESSION_CULTURE_DESCRIPTION',
   },
   conflictAndDifficultSituationManagement: {
      key: 'conflictAndDifficultSituationManagement',
      title: 'CONFLICT_AND_DIFFICULT_SITUATION_MANAGEMENT_TITLE',
   },
};
export const thirdStepLabelMap: Record<string, LabelNameMap> = {
   workingHoursAndDisciplineRespect: {
      key: 'workingHoursAndDisciplineRespect',
      title: 'WORKING_HOURS_AND_DISCIPLINE_RESPECT_TITLE',
   },
   timeManagement: {
      key: 'timeManagement',
      title: 'TIME_MANAGEMENT_TITLE',
      description: 'TIME_MANAGEMENT_DESCRIPTION',
   },
   timelyAndEffectiveInterventionPlanning: {
      key: 'timelyAndEffectiveInterventionPlanning',
      title: 'TIMELY_AND_EFFECTIVE_INTERVENTION_PLANNING_TITLE',
   },
   initiative: {
      key: 'initiative',
      title: 'INITIATIVE_TITLE',
      description: 'INITIATIVE_DESCRIPTION',
   },
   flexibility: {
      key: 'flexibility',
      title: 'FLEXIBILITY_TITLE',
      description: 'FLEXIBILITY_DESCRIPTION',
   },
   decisiveness: {
      key: 'decisiveness',
      title: 'DECISIVENESS_TITLE',
      description: 'DECISIVENESS_DESCRIPTION',
   },
};
export const fourthStepLabelMap: Record<string, LabelNameMap> = {
   respectForDiversity: {
      key: 'respectForDiversity',
      title: 'RESPECT_FOR_DIVERSITY_TITLE',
      description: 'RESPECT_FOR_DIVERSITY_DESCRIPTION',
   },
   userEmpowerment: {
      key: 'userEmpowerment',
      title: 'USER_EMPOWERMENT_TITLE',
      description: 'USER_EMPOWERMENT_DESCRIPTION',
   },
   rightsAdvocacy: {
      key: 'rightsAdvocacy',
      title: 'RIGHTS_ADVOCACY_TITLE',
      description: 'RIGHTS_ADVOCACY_DESCRIPTION',
   },
   maintainingProfessionalBoundaries: {
      key: 'maintainingProfessionalBoundaries',
      title: 'MAINTAINING_PROFESSIONAL_BOUNDARIES_TITLE',
   },
};
export const fifthStepLabelMap: Record<string, LabelNameMap> = {
   opennessToSupervision: {
      key: 'opennessToSupervision',
      title: 'OPENNESS_TO_SUPERVISION_TITLE',
      description: 'OPENNESS_TO_SUPERVISION_DESCRIPTION',
   },
   criticalSelfAssessment: {
      key: 'criticalSelfAssessment',
      title: 'CRITICAL_SELF_ASSESSMENT_TITLE',
      description: 'CRITICAL_SELF_ASSESSMENT_DESCRIPTION',
   },
   learningAndProfessionalDevelopment: {
      key: 'learningAndProfessionalDevelopment',
      title: 'LEARNING_AND_PROFESSIONAL_DEVELOPMENT_TITLE',
      description: 'LEARNING_AND_PROFESSIONAL_DEVELOPMENT_DESCRIPTION',
   },
};
